import React from 'react';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';

class SMORoomEditBaseFragment extends SMDashboardBaseView {
  
  fragmentStyle(){
    return {
      display: this.state.isCurrent ? "block" : "none"
    };
  }
  
  isCurrent(props){
    return props.selectedFragment == props.fragmentIndex;
  }
  
  sizeToFit() {
    let $mainTable = $("#js-split_view-main"),
        $mainTableFooter = $(this.refs.mainTableFooter);
        
    // main
    $mainTableFooter.outerWidth($mainTable.outerWidth());
  }
  
  didSelectNextFragment(e) {
    if(this.props.delegate && typeof this.props.delegate.nextButtonDidSelect === 'function'){
      this.props.delegate.nextButtonDidSelect();
    }
    e.preventDefault();
  }
  // delegate
  textFieldDidEndEditing(e) {
    let payload = {};
    payload[e.currentTarget.name] = e.currentTarget.value;
    $(document).trigger("SMRoomHandleUpdate", [{name: e.currentTarget.name, payload: payload}]);
  }
  
  textAreaDidEndEditing(e) {
    let payload = {};
    payload[e.currentTarget.name] = e.currentTarget.value;
    $(document).trigger("SMRoomHandleUpdate", [{name: e.currentTarget.name, payload: payload}]);
  }
  
  radioButtonDidChangeValue(e) {
    let payload = {};
    payload[e.currentTarget.name] = e.currentTarget.value;
    $(document).trigger("SMRoomHandleUpdate", [{name: e.currentTarget.name, payload: payload}]);
  }
  
  checkBoxDidChangeValue(e) {
    $(document).trigger("SMRoomHandleUpdateCheckBox", [{checked: e.currentTarget.checked, name: e.currentTarget.name, value: e.currentTarget.value}]);
  }
  
  fileFieldDidChangeValue(e) {
    $(document).trigger("SMRoomHandleUploadFile", [{name: e.currentTarget.name, files: e.currentTarget.files}]);
  }
  
  sortOrderDidChange(e, data) {
    let payload = {};
    payload[data.name] = data.items;
    $(document).trigger("SMRoomHandleUpdate", [{name: e.currentTarget.name, payload: payload}]);
  }
  
}

export default SMORoomEditBaseFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditBaseFragment.jsx